<template>
  <div class="rbot-box">
    <!-- 操作栏 -->
    <div class="action-bar">
      <el-select v-model="param.type" size="small" placeholder="机器人类型" clearable @change="getRobotList('status')">
        <el-option v-for="item in type" :value="item.value" :label="item.label" :key="item.value"></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="addRobotConfig('add')">+新增机器人配置</el-button>
    </div>
    <!-- 表格数据 -->
    <el-table :data="tableData" border v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" ref="multipleTable">
      <el-table-column prop="id" label="ID" align="center" width="220" fixed>
        <template slot-scope="scope">
          {{scope.row.id || '未知'}}
        </template>
      </el-table-column>
      <el-table-column prop="type" label="机器人类型" align="center" width="180">
        <template slot-scope="scope">
          {{scope.row.type === 'COMMENT' ? '评论机器人' : '影院机器人'}}
        </template>
      </el-table-column>
      <el-table-column prop="isActive" label="是否开启" align="center" width="180">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isActive" disabled=""></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="from" label="每日开始时间" align="center" width="180">
        <template slot-scope="scope">
          <span>{{scope.row.from }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="to" label="每日结束时间" align="center" width="180">
        <template slot-scope="scope">
          <span>{{scope.row.to }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalLimit" label="机器人评论总数" align="center" width="180">
        <template slot-scope="scope">
          <span>{{scope.row.totalLimit }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="pureLimit" label="单个机器人评论总数" align="center" width="180">
        <template slot-scope="scope">
          <span>{{scope.row.pureLimit }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="maxCommentNum" label="参与评论视频最大评论数" align="center" width="180">
        <template slot-scope="scope">
          <span>{{scope.row.maxCommentNum }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="maxFakeLikes" label="视频点赞数最大值" align="center" width="180">
        <template slot-scope="scope">
          <span>{{scope.row.maxFakeLikes }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="minFakeLikes" label="视频点赞数最小值" align="center" width="180">
        <template slot-scope="scope">
          <span>{{scope.row.minFakeLikes }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="maxFakePlayCount" label="视频播放量最大值" align="center" width="180">
        <template slot-scope="scope">
          <span>{{scope.row.maxFakePlayCount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="minFakePlayCount" label="视频播放量最小值" align="center" width="180">
        <template slot-scope="scope">
          <span>{{scope.row.minFakePlayCount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="frequency" label="发表频率（秒/每条）" align="center" width="180">
        <template slot-scope="scope">
          <span>{{scope.row.frequency }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center" width="180">
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="更新时间" align="center" width="180">
        <template slot-scope="scope">
          <span>{{scope.row.updatedAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button type="success" size="mini" icon="el-icon-edit" @click="addRobotConfig('edit',scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 30]" :current-page="param.pageNumber" :page-size="param.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <add-popup ref="addPopup" @handlerRobot="getRobotList('status')"></add-popup>
  </div>
</template>
<script>
import API from '@/api'
import addPopup from './components/addRobotPopup'
export default {
  data() {
    return {
      type: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '评论机器人',
          value: 'COMMENT'
        },
        {
          label: '影院机器人',
          value: 'FILM'
        }
      ],
      tableData: [],
      loading: false,
      total: '',
      param: {
        pageNumber: 1,
        pageSize: 10,
        type: ''
      }
    }
  },
  components: {
    addPopup
  },
  created() {
    this.getRobotList()
  },
  methods: {
    // 请求机器人列表
    getRobotList(type) {
      if (type === 'status') {
        this.param.pageNumber = 1
      }
      this.loading = true
      API.getRbotList(this.param).then(res => {
        if (res.code === 200 && res.data.list.length > 0) {
          this.tableData = res.data.list
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.param.pageSize = size
      this.param.pageNumber = 1
      this.getRobotList()
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.param.pageNumber = pageNumber
      this.getRobotList()
    },
    // 打开编辑、添加弹窗
    addRobotConfig(type, data) {
      this.$refs.addPopup.open(type, data)
    }
  }
}
</script>
<style lang="scss">
// .rbot-box {
// }
</style>